<template>
    <v-app>
        <template v-if="$auth.ready()">
            <component v-bind:is="getLayout"></component>
        </template>
        <template v-if="!$auth.ready()">
            <v-container class="fill-height">
                <v-row class="justify-center">
                    <speed-spinner :show="true"></speed-spinner>
                </v-row>
            </v-container>
        </template>
    </v-app>
</template>

<script>
import SpeedSpinner from "./components/Common/CrmSpinner"
import MainLayout from "./components/Layouts/MainLayout"
import DashboardLayout from "./components/Layouts/DashboardLayout"
import ErrorLayout from "./components/Layouts/ErrorLayout"
import {mapGetters} from "vuex";

export default {
    components: {
        SpeedSpinner,
        MainLayout,
        DashboardLayout,
        ErrorLayout,
    },
    data() {
        return {

        };
    },
    computed: {
        ...mapGetters({
            getLayout: 'getLayout'
        }),
    },
};
</script>
<style lang="scss">


    html, body {
        height: 100%;
    }

    a {
        text-decoration: none!important;
    }

    .cursor-pointer {
        cursor: pointer;
    }


    .v-data-table--mobile {
        &.set-tbody-d-table-row {
            tbody {
                display: table-row-group !important;
            }
        }
    }

    .full-container {
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }

    .v-slide-group__prev:not(.v-slide-group__prev--disabled) .v-icon,
    .v-slide-group__next:not(.v-slide-group__next--disabled) .v-icon {
        color: var(--v-primary-base) !important; /* активна стрілка = primary */
    }

    .v-slide-group__prev.v-slide-group__prev--disabled .v-icon,
    .v-slide-group__next.v-slide-group__next--disabled .v-icon {
        color: rgba(0,0,0,.26) !important; /* неактивна = сіра */
    }

</style>
